import { isJSXElement } from "@utils/common";
import Image from "next/image";
import React, { useRef } from "react";
interface StyleInterface {
    customStyles?: string;
    btnText?: string;
    titleContent?: string | JSX.Element;
    isIconBtn?: boolean;
    link?: string;
    isMobile?: boolean;
    textStyles?: string;
    imageSrc?: string;
    imageAlt?: string;
    onButtonClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

const TopNavBlock: React.FC<StyleInterface> = ({ customStyles, btnText, titleContent, link, isMobile = false, textStyles, imageSrc, imageAlt, onButtonClick }) => {
    const topBlk = useRef<HTMLDivElement>(null);

    const handleButtonClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (onButtonClick) {
            e.preventDefault();
            onButtonClick(e);
        }
    };

    return (
        <div ref={topBlk} className={`above-navbar px-2 z-10 w-full bg-green-500 py-3 ${customStyles}`} style={{ background: "linear-gradient(#000, #000)" }}>
            <div className="flex justify-center items-center lg:space-y-0 space-y-2">
                {isMobile ? (
                    <>
                        {imageSrc ? (
                            <a href={link} target="_blank" rel="noreferrer" className="cursor-pointer hover:opacity-90 transition-opacity">
                                <Image src={imageSrc} alt={imageAlt || "Banner"} width={530} height={67} />
                            </a>
                        ) : (
                            <p className="pt-1 text-sm font-semibold text-center text-white h-12 md:h-auto">
                                {isJSXElement(titleContent) ? titleContent : titleContent}
                                {btnText && (
                                    <a
                                        className="pl-2 px-2 text-sm font-semibold rounded-sm whitespace-nowrap hover:no-underline cursor-pointer text-black bg-white hover:bg-blue-200"
                                        href={onButtonClick ? "#" : link}
                                        target={onButtonClick ? undefined : "_blank"}
                                        rel={"noreferrer"}
                                        id="banner-action_btn"
                                        onClick={handleButtonClick}
                                    >
                                        {btnText}
                                    </a>
                                )}
                            </p>
                        )}
                    </>
                ) : (
                    <div className="md:block hidden">
                        <div className="max-w-6xl flex items-center justify-center gap-5 w-full">
                            {imageSrc ? (
                                <a href={link} target="_blank" rel="noreferrer" style={{ width: "100%" }} className="cursor-pointer hover:opacity-90 transition-opacity">
                                    <Image src={imageSrc} alt={imageAlt || "Banner"} width={830} height={67} />
                                </a>
                            ) : (
                                <>
                                    <p className={`${textStyles ? textStyles : "text-xl"} font-semibold text-center text-white`}>{titleContent}</p>
                                    {btnText && (
                                        <a
                                            className="text-base text-center font-semibold cursor-pointer text-black hover:no-underline px-3 py-1 rounded-md whitespace-nowrap bg-white hover:bg-blue-200"
                                            href={onButtonClick ? "#" : link}
                                            target={onButtonClick ? undefined : "_blank"}
                                            rel={"noreferrer"}
                                            onClick={handleButtonClick}
                                        >
                                            {btnText}
                                        </a>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopNavBlock;
